import api from './axiosConfig';
import { getStore } from "../utils/localStorageUtil";

/**
 * Capture browser and connection context for error logging
 * @returns {Object} Context information about the client
 */
const getCaptureContext = () => {
    const context = {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userAgent: navigator.userAgent,
        url: window.location.href,
        connection_info: {},
    };

    // Capture connection information if available (Chrome/Edge)
    if (navigator.connection || navigator.mozConnection || navigator.webkitConnection) {
        const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        context.connection_info = {
            effectiveType: conn.effectiveType || null,
            downlink: conn.downlink || null,
            rtt: conn.rtt || null,
            saveData: conn.saveData || false,
        };
    }

    return context;
};

/**
 * Send an error log to the BFF
 * @param {string} errorType - Type of error (e.g., 'team_data_fetch', 'api_timeout')
 * @param {Error} error - The error object
 * @param {Object} additionalContext - Additional context specific to the error
 * @returns {Promise<void>}
 */
export const logError = async (errorType, error, additionalContext = {}) => {
    try {
        const localStore = getStore();
        const countryCode = localStore?.isoCountry?.toUpperCase() || 'GL';

        const captureContext = getCaptureContext();

        const errorLogData = {
            error_type: errorType,
            country_code: countryCode,
            error_message: error.message || 'Unknown error',
            error_details: {
                stack: error.stack || null,
                name: error.name || null,
                ...additionalContext,
            },
            url: captureContext.url,
            timezone: captureContext.timezone,
            connection_info: captureContext.connection_info,
            timestamp: new Date().toISOString(),
        };

        // Send to BFF endpoint - non-blocking
        await api.post('/siteErrorLog', errorLogData);
    } catch (logError) {
        // Silently fail - don't break the application if error logging fails
        console.error('Failed to log error:', logError);
    }
};
